export class JobBookmark {
    constructor() {}

    jobId: string;
    accountId: string;
}